"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
const thunkReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes_1.THUNKTANK_ADD: {
            return state;
        }
        case actionTypes_1.THUNKTANK_REMOVE: {
            return Object.assign(Object.assign({}, state), { isDeleted: true, error: null, data: null });
        }
        case actionTypes_1.THUNKTANK_RESET: {
            return Object.assign(Object.assign({}, state), { isDeleted: false, isLoading: false, error: null, data: null });
        }
        case actionTypes_1.THUNKTANK_LOADING: {
            return Object.assign(Object.assign({}, state), { isLoading: true });
        }
        case actionTypes_1.THUNKTANK_SET_DATA: {
            const { data } = action;
            return Object.assign(Object.assign({}, state), { isLoading: false, data: state.isDeleted ? null : data });
        }
        case actionTypes_1.THUNKTANK_SET_ERROR: {
            const { error } = action;
            return Object.assign(Object.assign({}, state), { isLoading: false, error: state.isDeleted ? null : error });
        }
        default:
            return null;
    }
};
exports.default = thunkReducer;
